import React, { useEffect, useState, memo } from "react";
import { useFavorite } from "modules/Favorites/hooks";
import { useAuthModal } from "core/context";
import Icon from "core/assets/icons";
import CDialogShareSns from "../Share/CDialogShareSns";
import { config } from "core/config/app";
import { getYouTubeThumbnail } from "core/utils/helper";

export type IProps = {
  id: number,
  dataCount?: number,
  onChange?: (id: number, state: boolean) => void,
  type?: 'post' | 'comment',
  className?: string;
  reload?: (cb: any) => void;
  viewOnly?: boolean;
  item?: any;
};

export const mapTermHostHompage = (text: any) => {
  if (config.environment === 'production') {
    return text
  }
  let data = text
  if (data?.includes('//heycooker.e777.biz')) {
    console.log('mapTermHostHompage', data)
    data = data.replace('//heycooker.e777.biz', "//heycooker.com")
  }
  return data
}

export const mapTermPrefix = (text: any) => {
  const data = text
  if(!data) {
    return config.webviewVersion
  }
  const prefix = data.replace("/", "");
  return prefix
}

const CShareComunity = ({
  id,
  onChange,
  type = 'post',
  className,
  reload,
  dataCount = 0,
  viewOnly = false,
  item,
}: IProps) => {

  const { openModal, token } = useAuthModal();
  const { handleFavorite } = useFavorite()
  const [stateActive, setStateActive] = useState<boolean>(false);
  const [countShare, setCountShare] = useState<number>(dataCount);

  const langCurrent = (window as any)._APP_LANG
  let link = '';
  const hostHome = `${mapTermHostHompage(config.homepageUrl)}`;
  let linkShareSns = hostHome;
  let envApp = 'dev';
  const dataShareSns = ``;
  const paramsShare = (envApp: any) => {
    const paramUrlShare = `communityId=${id}&v=${config.apiVersion}&lang=${langCurrent}&data=${dataShareSns}&ev=${envApp}&va=${mapTermPrefix(config.basename)}`;
    const encodedString = btoa(unescape(encodeURIComponent(paramUrlShare))); // Mã hóa
    return encodedString;
  }
  if (config.environment === 'development') {
    linkShareSns = `${hostHome}/share.php?token=${paramsShare(envApp)}`;
    link = linkShareSns;
  }
  if (config.environment === 'production') {
    envApp = 'pro';
    linkShareSns = `${hostHome}/share.php?token=${paramsShare(envApp)}`;
    link = linkShareSns;
  }


  useEffect(() => {
    setCountShare(dataCount)
  }, [dataCount])

  const toggleFavorite = () => {
    if (viewOnly) {
      return
    }
    onChange?.(id, !stateActive)
    if (id == 0) {
      handleFavorite({
        id: String(id),
        stateActive: !stateActive,
      })
    }
    setStateActive(true)
  }

  const _handleClickNote = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();

    if (!token) {
      openModal(() => {
        reload?.((newState: boolean) => {
          if (!newState) {
            document.getElementById(`NoteItem-${id}`)?.click()
          }
        })
      });
      return;
    }

    toggleFavorite();
  };

  return (
    <>
      {type === 'post' ? (
        <span
          className={`flex items-center ${className}`}
          onClick={_handleClickNote}
          id={`NoteItem-${id}`}
        >
          <img className="mr-[5px]" src={Icon.SharePost} alt={'favorite'} />
          <label className={`text-[11px] text-[#333333] ${viewOnly ? ' !text-[#777777]' : ''}`}>
            {countShare}
          </label>
        </span>
      ) : (
        <span
          className={`flex items-center  ${className}`}
          onClick={_handleClickNote}
          id={`NoteItem-${id}`}
        >
          <label className={`text-[11px] text-[#333333] mr-[5px] ${viewOnly ? ' !text-[#777777]' : ''}`}>{countShare}</label>
          <img src={Icon.SharePost} alt={'favorite'} />
        </span>
      )}
      <div className="hidden">
        <CDialogShareSns 
          onClose={() => { setStateActive(false) }} 
          isOpen={stateActive} 
          id={id} 
          title={''}
          urlImg={getYouTubeThumbnail(item?.video_id) || Icon.NoImage}
          link={link}
          post={item}
          postType="community"
        />
      </div>

    </>
  );
};


export default memo(CShareComunity);
